import $ from 'jquery';
import { CurrentUser, EmbeddedUpload, EnvironmentUrls, Endpoints } from 'Roblox';

document.addEventListener('DOMContentLoaded', () => {
  const uploadButton = $('#upload-button');
  const estimateButton = $('#estimate-price-button');
  const audioBucketData = $('#audio-bucket-data');
  const assetTypeId = $('#assetTypeId').val();
  const captchaEnabledElem = $('#captchaEnabled');
  const captchaTokenElem = $('#captchaToken');
  const captchaProviderElem = $('#captchaProvider');
  const uploadFeeItemErrorElm = $('#upload-fee-item-result-error');
  const uploadFeeItemSuccessElm = $('#upload-fee-item-result-success');
  const isSound = parseInt(assetTypeId, 10) === 3;
  const invalidFileExtension = isSound
    ? EmbeddedUpload.Resources.invalidSoundFile
    : EmbeddedUpload.Resources.invalidImageFile;
  const validFileExtensions = isSound
    ? ['.mp3']
    : ['.png', '.jpg', '.jpeg', '.jpe', '.bmp', '.tga'];
  const uploadableAvatarAssetTypes = [2, 11, 12];
  const templateUploadableAvatarAssetTypes = [11, 12];
  const postMessageMethods = {
    verifyCaptcha: 'verifyCaptcha',
    confirmTransaction: 'confirmTransaction',
    declineTransaction: 'declineTransaction',
    insufficientFundsForTransaction: 'insufficientFunds'
  };
  const creatorTypes = {
    user: 'User',
    group: 'Group'
  };

  if (uploadableAvatarAssetTypes.includes(getAssetTypeIdNumber())) {
    showUploadFeeInUploadButton();
  }

  if (isSound && $('#isOggUploadEnabled').val().toLowerCase() === 'true')
    validFileExtensions.push('.ogg');

  $('ul.nav-pills li').click(function (e) {
    e.preventDefault();
    $('.nav-pills li.active').removeClass('active');
    $(this).addClass('active');
    const selectedAssetTypeId = $(this).data('asset-type-id');
    $('input[name=assetTypeId]').val(selectedAssetTypeId);
  });

  // client-side file extension validation
  $('#file').change(function () {
    $('#upload-result').remove();
    $('#file-error').text('');
    $('#name-error').text('');

    if (!$('#file').val()) return; // no file selected

    const fileName = $('#file')
      .val()
      .replace(/^.*[\\\/]/, '');
    const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();

    if ($.inArray(fileExtension, validFileExtensions) === -1) {
      $('#file-error').text(invalidFileExtension);
    } else {
      $('#name').val(fileName.slice(0, -fileExtension.length));
      $('#name').select();
    }
  });

  function validateName() {
    if (!!$('#file').val() && !$('#name').val().trim()) {
      $('#name-error').text(EmbeddedUpload.Resources.noName);
      return false;
    }
    return true;
  }

  function toggleButtonEnabled(button, isEnabled, visible) {
    if (isEnabled) {
      button.addClass('btn-primary').removeClass('btn-disabled-primary');
      button.removeAttr('disabled');
    } else {
      button.addClass('btn-disabled-primary').removeClass('btn-primary');
      button.attr('disabled', 'disabled');
    }
    button[isEnabled || visible ? 'removeClass' : 'addClass']('invisible');
  }

  $('#name').focusout(validateName);

  function submitUpload(elem) {
    if (elem.attr('disabled')) {
      return;
    }
    toggleButtonEnabled(uploadButton, false, true);

    const onVerificationPageElem = $('#onVerificationPage');
    if (!onVerificationPageElem.get(0) || onVerificationPageElem.val() != 'True') {
      if (!$('#file').val()) {
        $('#file-error').text(EmbeddedUpload.Resources.noFile);
        toggleButtonEnabled(uploadButton, true, true);
        return;
      }

      const fileName = $('#file')
        .val()
        .replace(/^.*[\\\/]/, '');
      const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
      if ($.inArray(fileExtension, validFileExtensions) === -1) {
        $('#file-error').text(invalidFileExtension);
        toggleButtonEnabled(uploadButton, true, true);
        return;
      }

      if (!validateName()) {
        toggleButtonEnabled(uploadButton, true, true);
        return;
      }
    }

    $('#loading-container').show();
    $('#upload-button').hide();
    $('#cancel-upload-button').hide();
    $('#purchase-amount-message').hide();

    if (uploadableAvatarAssetTypes.includes(getAssetTypeIdNumber())) {
      checkUploadFee();
    } else {
      handleInputForNonUploadFeeTypes();
    }
  }

  function handleInputForNonUploadFeeTypes() {
    const shouldCaptcha = captchaEnabledElem.val().toLowerCase() === 'true';
    if (shouldCaptcha) {
      verifyCaptcha(function (success) {
        if (success) {
          $('#upload-form').submit();
        } else {
          window.location.reload();
        }
      });
    } else {
      $('#upload-form').submit();
    }
  }

  function getAssetTypeIdNumber() {
    const assetTypeIdNumber = parseInt(assetTypeId, 10);

    return assetTypeIdNumber;
  }

  function getGroupIdNumber() {
    const groupIdValue = $('#groupId').val();
    const groupIdNumber = parseInt(groupIdValue, 10);
    if (isNaN(groupIdNumber)) {
      return undefined;
    }

    return groupIdNumber;
  }

  function checkGroupElem() {
    const groupId = $('#groupId').val();
    return groupId && groupId.length > 0;
  }

  function getConfigFileForUploadFeeItems() {
    let id = CurrentUser.userId;
    let type = creatorTypes.user;
    if (checkGroupElem()) {
      id = getGroupIdNumber();
      type = creatorTypes.group;
    }

    const configContent = {
      name: $('#name').val(),
      description: 'New clothing asset',
      creatorTargetId: id,
      creatorType: type
    };

    return JSON.stringify(configContent);
  }

  function verifyCaptcha(cb) {
    // we do postmessage here.
    const data = {
      method: postMessageMethods.verifyCaptcha,
      isGroupUpload: checkGroupElem(),
      assetTypeId: getAssetTypeIdNumber(),
      groupId: getGroupIdNumber()
    };
    window.parent.postMessage(data, '*');

    // now create listener.
    window.addEventListener('message', function (event) {
      if (event.origin === window.location.origin) {
        if (event.data && event.data.method === postMessageMethods.verifyCaptcha) {
          captchaTokenElem.val(event.data.captchaToken);
          captchaProviderElem.val(event.data.captchaProvider);
          cb(event.data.success);
        }
      }
    });
  }

  function showUploadFeeInUploadButton() {
    const fileExtension = '.png';
    const fileFormData = new FormData();
    const configBlob = new Blob([getConfigFileForUploadFeeItems()], { type: 'application/json' });
    fileFormData.append('config', configBlob, 'config.json');

    const imageBlob = new Blob();
    fileFormData.append('GetUploadFeePrice', imageBlob, `GetUploadFeePrice${fileExtension}`);

    $.ajax({
      type: 'POST',
      url: `${
        EnvironmentUrls.itemConfigurationApi
      }/v1/avatar-assets/${getAssetTypeIdNumber()}/get-upload-fee`,
      data: fileFormData,
      contentType: false,
      processData: false,
      success(response) {
        if (response.price > 0) {
          uploadButton[0].innerHTML = `Upload for ${response.price} Robux`;
        }
      }
    });
  }

  function checkUploadFee() {
    uploadFeeItemErrorElm[0].innerHTML = '';
    uploadFeeItemErrorElm[0].classList.add('hidden');

    const fileName = $('#file')
      .val()
      .replace(/^.*[\\\/]/, '');
    const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
    const fileFormData = new FormData();
    const configBlob = new Blob([getConfigFileForUploadFeeItems()], { type: 'application/json' });
    fileFormData.append('config', configBlob, 'config.json');

    const fileType = `image/${fileExtension.replace('.', '')}`;
    const imageBlob = new Blob([$('#file').prop('files')[0]], { type: fileType });
    fileFormData.append(fileName, imageBlob, fileName + fileExtension);

    $.ajax({
      type: 'POST',
      url: `${
        EnvironmentUrls.itemConfigurationApi
      }/v1/avatar-assets/${getAssetTypeIdNumber()}/get-upload-fee`,
      data: fileFormData,
      contentType: false,
      processData: false,
      success(response) {
        if (response.canAfford) {
          const uploadFee = response.price;
          checkCaptchaForUploadFeeItems(uploadFee);
        } else {
          $('#loading-container').hide();
          uploadFeeItemErrorElm[0].innerHTML = 'Insufficient funds';
          uploadFeeItemErrorElm[0].classList.remove('hidden');
        }
      },
      error(response) {
        toggleButtonEnabled(uploadButton, true, true);
        $('#upload-button').show();
        document.getElementById('upload-form').reset();

        if (response.status === 400) {
          if (response.responseJSON.errors[0].code === 2) {
            handleInputForNonUploadFeeTypes();
          } else {
            $('#loading-container').hide();
            uploadFeeItemErrorElm[0].innerHTML = 'Please make sure your file is an image';
            uploadFeeItemErrorElm[0].classList.remove('hidden');
          }
        } else if (response.status === 503) {
          handleInputForNonUploadFeeTypes();
        } else if (response.status === 404) {
          handleInputForNonUploadFeeTypes();
        } else {
          $('#loading-container').hide();
          uploadFeeItemErrorElm[0].innerHTML =
            'An unexpected error occured. Please try again later';
          uploadFeeItemErrorElm[0].classList.remove('hidden');
        }
      }
    });
  }

  function checkCaptchaForUploadFeeItems(uploadFee) {
    let groupId = 'null';
    if (getGroupIdNumber() !== undefined) {
      groupId = getGroupIdNumber();
    }
    $.ajax({
      type: 'POST',
      url: `${
        EnvironmentUrls.itemConfigurationApi
      }/v1/avatar-assets/${getAssetTypeIdNumber()}/upload-captcha-test?groupId=${groupId}`,
      contentType: false,
      processData: false,
      success(response) {
        if (response.success === true) {
          confirmTransaction(uploadFee);
        } else {
          verifyCaptcha(function (success) {
            if (success) {
              confirmTransaction(uploadFee);
            } else {
              window.location.reload();
            }
          });
        }
      },
      error(response) {
        toggleButtonEnabled(uploadButton, true, true);
        $('#upload-button').show();
        document.getElementById('upload-form').reset();

        uploadFeeItemErrorElm[0].innerHTML = 'A Captcha Error Occured';
        uploadFeeItemErrorElm.classList[0].remove('hidden');
      }
    });
  }

  function confirmTransaction(uploadFee) {
    if (uploadFee <= 0) {
      uploadForFeeItems();
      return;
    }

    const data = {
      method: postMessageMethods.confirmTransaction,
      price: uploadFee,
      assetType: getAssetTypeIdNumber(),
      isGroupUpload: getGroupIdNumber() !== undefined
    };
    window.parent.postMessage(data, '*');

    // now create listener.
    window.addEventListener('message', function (event) {
      if (event.origin === window.location.origin) {
        if (event.data && event.data.method === postMessageMethods.declineTransaction) {
          window.location.reload();
        }
        if (event.data && event.data.method === postMessageMethods.confirmTransaction) {
          uploadForFeeItems();
        }
      }
    });
  }

  function uploadForFeeItems() {
    const fileName = $('#file')
      .val()
      .replace(/^.*[\\\/]/, '');

    const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
    const configFormData = new FormData();
    const configBlob = new Blob([getConfigFileForUploadFeeItems()], { type: 'application/json' });
    configFormData.append('config', configBlob, 'config.json');

    const fileType = `image/${fileExtension.replace('.', '')}`;
    const imageBlob = new Blob([$('#file').prop('files')[0]], { type: fileType });
    configFormData.append(fileName, imageBlob, fileName + fileExtension);
    const captchaContent = {
      captchaToken: captchaTokenElem.val(),
      captchaProvider: captchaProviderElem.val()
    };
    const captchaBlob = new Blob([JSON.stringify(captchaContent)], { type: 'application/json' });
    configFormData.append('captcha-token-request', captchaBlob, 'captcha-token-request.json');

    $.ajax({
      type: 'POST',
      url: `${
        EnvironmentUrls.itemConfigurationApi
      }/v1/avatar-assets/${getAssetTypeIdNumber()}/upload`,
      data: configFormData,
      contentType: false,
      processData: false,
      success(response) {
        $('#loading-container').hide();
        document.getElementById(
          'upload-fee-confirmation-link'
        ).href = `${EnvironmentUrls.websiteUrl}/catalog/${response.assetId}`;
        uploadFeeItemSuccessElm[0].classList.remove('hidden');
        toggleButtonEnabled(uploadButton, true, true);
        window.top.location.reload();
      },
      error(response) {
        toggleButtonEnabled(uploadButton, true, true);
        $('#upload-button').show();
        document.getElementById('upload-form').reset();
        if (response.status === 400) {
          $('#loading-container').hide();
          if (response.responseJSON.errors[0].code === 7) {
            uploadFeeItemErrorElm[0].innerHTML = 'Upload failed. Did you use the template?';
          } else if (response.responseJSON.errors[0].code === 16) {
            uploadFeeItemErrorElm[0].innerHTML = 'Asset name was moderated. Please try again.';
          }
          uploadFeeItemErrorElm[0].classList.remove('hidden');
        } else if (response.status === 402) {
          $('#loading-container').hide();
          uploadFeeItemErrorElm[0].innerHTML = 'Insufficient funds.';
          uploadFeeItemErrorElm[0].classList.remove('hidden');
        } else if (response.status === 403 && response.responseJSON.errors[0].code === 15) {
          $('#loading-container').hide();
          uploadFeeItemErrorElm[0].innerHTML = 'Captcha required.';
          uploadFeeItemErrorElm[0].classList.remove('hidden');
        } else if (response.status === 500 && response.responseJSON.errors[0].code === 12) {
          if (templateUploadableAvatarAssetTypes.includes(getAssetTypeIdNumber())) {
            $('#loading-container').hide();
            uploadFeeItemErrorElm[0].innerHTML = 'Upload failed. Did you use the template?';
            uploadFeeItemErrorElm[0].classList.remove('hidden');
          } else {
            $('#loading-container').hide();
            uploadFeeItemErrorElm[0].innerHTML = 'Upload failed. Please try again later.';
            uploadFeeItemErrorElm[0].classList.remove('hidden');
          }
        } else {
          $('#loading-container').hide();
          uploadFeeItemErrorElm[0].innerHTML =
            'An unexpected error occured. Please try again later';
          uploadFeeItemErrorElm[0].classList.remove('hidden');
        }
      }
    });
  }

  uploadButton.click(function () {
    submitUpload($(this));
  });

  estimateButton.click(function () {
    if ($(this).attr('disabled')) {
      return;
    }

    if (isSound) {
      toggleButtonEnabled(estimateButton, false, true);
      $.ajax({
        type: 'POST',
        url: Endpoints.getAbsoluteUrl('/build/verifyaudio'),
        data: new FormData($('form')[0]),
        contentType: false,
        processData: false,
        success(estimate) {
          $('#file-error').text(estimate.message);
          if (estimate.price) {
            uploadButton.text(`Purchase for ${estimate.price} Robux`);
          }
          toggleButtonEnabled(
            uploadButton,
            !estimate.message && estimate.canAfford,
            !!estimate.price
          );
          toggleButtonEnabled(estimateButton, false, !estimate.price);
        },
        error() {
          toggleButtonEnabled(estimateButton, true, true);
        }
      });
    }
  });

  // make sure the correct place is selected if page is being redirected from a dropdown
  const selectedPlaceIdElem = $('#selectedPlaceId', parent.document);
  if (selectedPlaceIdElem) {
    const placeSelector = $('#badge-place-select');
    if (placeSelector && placeSelector.children('option').length > 0) {
      const placeId = selectedPlaceIdElem.val();
      const existsPlace = $(`#badge-place-select option[value=${placeId}]`).length > 0;
      if (existsPlace) {
        placeSelector.val(placeId);
      }
    }
  }

  const audioBucketList = [];
  const audioNames = ['shortsoundeffect', 'longsoundeffect', 'music', 'longmusic'];

  for (let i = 0; i < audioNames.length; i++) {
    if (audioBucketData.data(`${audioNames[i]}-enabled`)) {
      audioBucketList.push({
        size: audioBucketData.data(`${audioNames[i]}-size`),
        price: audioBucketData.data(`${audioNames[i]}-price`)
      });
    }
  }

  if (audioBucketData.data('audiobuckets-enabled') && audioBucketList.length > 0) {
    $("#file[accept='audio/*']").change(function () {
      $('#file-error').text('');
      toggleButtonEnabled(estimateButton, false, true);
      toggleButtonEnabled(uploadButton, false, false);

      const file = this.files && this.files[0];
      if (!file) {
        return;
      }

      let hasBucket = false;
      if (file.size < 1) {
        $('#file-error').text(EmbeddedUpload.Resources.fileIsEmpty);
      } else if (file.size <= audioBucketData.data('max-audio-size')) {
        for (let i = 0; i < audioBucketList.length; i++) {
          const bucket = audioBucketList[i];
          if (file.size <= bucket.size) {
            hasBucket = true;
            break;
          }
        }
      } else {
        $('#file-error').text(EmbeddedUpload.Resources.fileTooLarge);
      }

      toggleButtonEnabled(estimateButton, hasBucket, true);
    });
  }
});
